import { AlpineComponent } from '@alpinejs/csp';

export const HeroesComicItem = (): AlpineComponent => ({
  visible: false,
  handleIntersect() {
    this.visible = true;
  },
  getClassName() {
    return this.visible ? 'visible' : '';
  }
});
